import gql from 'graphql-tag';

export const waitingFeedPostApprovalsQuery = gql`
  query waitingFeedPostApprovals {
    waitingFeedPostApprovals {
      id
      title
      description
      type
      createdAt
      imageUrl
      user {
        id
        name
      }
    }
  }
`;
